import styled from 'styled-components'

export const Container = styled.footer`
  border-top: 1px solid #E0E0E0;
  padding: 32px 24px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-inline: auto;
  max-width: 1242px;
  width: 100%;
`

export const Contact = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 32px;

  & > figure {
    max-width: 124px;

    & > img {
      width: 100%;
    }
  }

  & > div {
    align-items: center;
    display: flex;
    gap: 16px;

    & > p {
      align-items: center;
      color: #084F43;
      display: inline-flex;
      font-size: 0.875rem;
      font-weight: 600;
      gap: 8px;
      text-align: center;
      vertical-align: middle;

      text-align: center;
      vertical-align: middle;

      & > span {
        border: 1.5px solid #00A988;
        border-radius: 20px;
        color: #00A988;
        font-size: 1rem;
        font-weight: 600;
        padding: 4px 16px;
      }
    }

    & > div {
      align-items: center;
      display: flex;
      gap: 16px;

      & > p {
        align-items: center;
        color: #084F43;
        display: inline-flex;
        font-size: 0.875rem;
        font-weight: 600;
        gap: 8px;
        text-align: center;
        vertical-align: middle;
      }
    }
  }

  @media (max-width: 911px) {
    flex-direction: column;

    & > div {
      flex-direction: column;
    }
  }


  @media (max-width: 568px) {
    & > div {
      & > p {
        font-size: 1rem;
      }

      & > div {
        flex-direction: column;

        & > p {
          font-size: 1rem;
        }
      }
    }
  }
`

export const Terms = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 32px;

  & > a {
    color: #568BE1;
    font-size: 0.875rem;
    font-weight: 400;
    text-decoration: underline;
  }

  @media (max-width: 568px) {
    flex-direction: column;
    gap: 16px;
  }
`

export const Disclaimer = styled.p`
  color: #7E8691;
  font-size: 12px;
  font-weight: 400;
  text-align: center;

  & > a {
    color: #7E8691;
    text-decoration: underline;
  }
`

export const Copyright = styled.p`
  color: #1D1D1D;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: center;
  vertical-align: middle;
`
